module.exports = __webpack_public_path__ + "img/karamoja4.6de2a01a.jpg";